import update from "immutability-helper";

const events = (
  state = {
    fetched: false,
  },
  action,
) => {
  switch (action.type) {
    case "EVENTS_UPDATE":
      state = update(state, {
        $set: action.payload,
      });
      break;

    default:
      break;
  }
  return state;
};

export default events;



// WEBPACK FOOTER //
// ./src/scenes/landingPage/components/events/services/eventsReducer.js